import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

const syllabusItems = [
  { classLabel: "Class - II", fileName: "syllabus-class2_pt-1.pdf" },
  { classLabel: "Class - III", fileName: "syllabus-class3_pt-1.pdf" },
  { classLabel: "Class - IV", fileName: "syllabus-class4_pt-1.pdf" },
  { classLabel: "Class - V", fileName: "syllabus-class5_pt-1.pdf" },
  { classLabel: "Class - VI", fileName: "syllabus-class6_pt-1.pdf" },
  { classLabel: "Class - VII", fileName: "syllabus-class7_pt-1.pdf" },
  { classLabel: "Class - VIII", fileName: "syllabus-class8_pt-1.pdf" },
  { classLabel: "Class - IX", fileName: "syllabus-classIX_pt-1.pdf" },
  { classLabel: "Class - X", fileName: "syllabus-classX_pt-1.pdf" },
  { classLabel: "Class - XI", fileName: "syllabus-classXI_pt-1.pdf" },
];

function SyllabusPT1() {
  useEffect(() => {
    document.title = "Syllabus PT-1 - St Peters Convent School Faridabad Haryana";
  }, []);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Academics</li>
          <li>Syllabus PT 1</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12">
              <h1 className="fw-bold">Syllabus - PT 1</h1>
            </div>
          </div>

          <div className="row">
            {syllabusItems.map((item) => (
              <div className="col-lg-3 col-md-6 mb-4" key={item.fileName}>
                <div className="card syllabus-card h-100 text-center">
                  <div className="card-body">
                    <div className="pdf-icon mb-3">📄</div>
                    <h6 className="fw-semibold">{item.classLabel}</h6>
                    <a
                      href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/${item.fileName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="click-text"
                    >
                      Click Here →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SyllabusPT1;
